module.exports = __webpack_public_path__ + "static/organize-recipes-5308c352c759d357337cc85b30ea5e96.mp4";